export default __webpack_public_path__ + "assets/cf1c2bc5171a5cf1eef69ded5ac03b57.jpeg";